// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"ColumnCard_tagsWrapper__UZaMt"};